import React, { useState } from 'react';
import { Label, Error, ClassHelper } from 'components/lib';
import Style from './input.tailwind.js';

const EyeOpen = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
  </svg>
);

const EyeOff = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

export function PasswordInput(props){

  const [error, setError] = useState(props.errorMessage || 'Ingrese su contraseña');
  const [show, setShow] = useState(false);

  function validate(e){
    let value = e ? e.target.value : '';
    let valid = undefined;

    if (props.required && value === '') valid = false;
    if (!props.required && value === '') valid = true;
    if (props.required && value !== '') valid = true;
    if (!props.required) valid = true;

    if (props.complexPassword){
      if (value.length < 8){
        valid = false;
        setError('La contraseña debe tener mínimo 8 caracteres');
      } else if (!/[A-Z]/.test(value)){
        valid = false;
        setError('La contraseña debe tener al menos una letra mayúscula');
      } else if (!/[a-z]/.test(value)){
        valid = false;
        setError('La contraseña debe tener al menos una letra minúscula');
      }
    }

    props.onChange?.(props.name, value, valid);
  }

  const passwordStyle = ClassHelper(Style, {
    textbox: true,
    className: props.className,
    error: props.valid === false,
    success: props.valid === true,
    warning: props.warning,
  });

  return(
    <div className={Style.input}>
      {props.label &&
        <Label text={props.label} required={props.required} for={props.name} />}

      <div style={{ position: 'relative' }}>
        <input
          type={show ? 'text' : 'password'}
          id={props.for}
          name={props.name}
          className={passwordStyle}
          style={{ paddingRight: '2.75rem' }}
          onChange={e => props.onChange?.(props.name, e.target.value, undefined)}
          onBlur={e => validate(e)}
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setShow(s => !s)}
          style={{
            position: 'absolute', right: '0.6rem', top: '50%', transform: 'translateY(-50%)',
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#9ca3af', padding: 4, display: 'flex', alignItems: 'center', lineHeight: 1,
          }}
        >
          {show ? <EyeOff /> : <EyeOpen />}
        </button>
      </div>

      {props.valid === false && <Error message={error}/>}
    </div>
  );
}
